export default {
  name: 'HeaderPhones',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {
    phones() {
      let list = [];
      if (this.data?.contacts) {
        list = ['phone1', 'phone2', 'phone3'].reduce((acc, key) => {
          let item = this.data.contacts[key];
          return item ? [...acc, item] : acc;
        }, []);
      }

      return list;
    }
  },
  methods: {}
};
